import React, { useState } from "react";
import {
  ActionButton,
  BalanceText,
  Container,
  ReloadIcon,
  Amount,
  Button,
  ButtonLight,
} from "./WalletCard.style";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import {
  TopUpOutlined,
  WithdrawFilled,
  BalanceLoading,
} from "@assets";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert, saveUser } from "@redux/auth/authSlice";
import { TOPUP_LK } from "@constants";
import Lottie from "react-lottie";
import { api } from "@api";
import { localStorage } from '@utils';
import { Space } from "antd";

const WalletCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { main_balance, bonus, is_in_game, can_exit_check } = useSelector(
    (state) => state.auth.user
  );
  const [loading, setLoading] = useState(false);

  const goToWallet = () => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PUBLIC_ROUTE.HOME}/${PRIVATE_ROUTE.WALLET}`);
  };

  const goToTopUp = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const goToWithdraw = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const checkIsLoggedIn = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
    }
    return isLoggedIn;
  };

  const checkExit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) {
      setLoading(true);
      api
        .checkExit()
        .then(({ user }) => {
          dispatch(saveUser(user));
          // save user to localstorage
          localStorage.setUser(user);
        })
        .catch(() => { });
    }
  }

  return (
    <Container>
      <ActionButton onClick={goToWallet}>
        <BalanceText>
          {is_in_game ? (
            <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              width={32}
              height={16}
              style={{
                position: 'absolute',
                top: '50%',
                left: '0',
                transform: 'translate(-0%, -50%)',
              }}
            />
          ) : (
            <>
              <Space>
                <p> {t("wallet.walletMyBalance")} </p>
                {can_exit_check && <ReloadIcon onClick={checkExit} />}
              </Space>
              <Amount>
                {getFormattedNumber(main_balance + bonus)}
              </Amount>
            </>

          )}
        </BalanceText>
      </ActionButton>

      <Button
        onClick={goToTopUp}
        type="secondary"
      >
        <TopUpOutlined />
        {t("wallet.walletTopUp")}
      </Button>

      <ButtonLight
        onClick={goToWithdraw}
        type="ghost"
      >
        <WithdrawFilled />
        {t("wallet.walletWithdraw")}
      </ButtonLight>
    </Container>
  );
};

export default WalletCard;
